import React from 'react';

const CButton = (props) => {

    return (
        <button {...props} >
            {props.children}
        </button>
    );
};

export default CButton;